//import * as React from 'react';


export const banklist = [    
    "DBS",
    "CITIBANK NA",
    "Citibank Singapore Limited",
    "HSBC Bank (Singapore) Limited",
    "OCBC",
    "Standard Chartered Bank Singapore Limited",
    "UOB",
    "BANK OF CHINA LTD",
    "CIMB Bank Berhad",
    "GXS Bank Pte. Ltd.",
    "HL Bank",
    "Maribank Singapore Private Limited",
    "RHB Bank Berhad",
    "TRUST BANK SINGAPORE LIMITED"

    // "DBS",
    // "OCBC",
    // "UOB",
    // "CITIBANK NA",
    // "Citibank Singapore Limited",
    // "HSBC",
    // "HSBC Bank (Singapore) Limited",
    // "Standard Chartered Bank",
    // "Standard Chartered Bank Singapore Limited",
    // "AMEX",
    // "ABSA Bank Ltd",
    // "ANZ Banking Group",
    // "Arab Bank PLC",
    // "Arab Banking Corporation BSC",
    // "Banca Monte dei Paschi di Siena S.p.A.",
    // "Bangkok Bank Public Company Ltd",
    // "BANK OF AMERICA NA",
    // "BANK OF CHINA LTD",
    // "Bank of Communications",
    // "Bank of East Asia Ltd",
    // "Bank of India",
    // "Bank of New Zealand",
    // "Bank of Nova Scotia",
    // "BANK OF TAIWAN",
    // "BARCLAYS BANK PLC",
    // "Bayerische Hypo-Und Vereinsbank",
    // "BNP Paribas",
    // "BNP PARIBAS SECURITIES SERVICES",
    // "Chang Hwa Commercial Bank Ltd",
    // "China CITIC Bank International Ltd",
    // "China Construction Bank",
    // "CIMB Bank Berhad",
    // "CLS BANK INTERNATIONAL",
    // "Commerzbank Aktiengesellschaft",
    // "Credit Agricole Corporate & Investment Bank-SG BR",
    // "CREDIT INDUSTRIEL ET COMMERCIAL",
    // "CREDIT SUISSE AG",
    // "CTBC Bank Co., Ltd",
    // "Deutsche Bank AG",
    // "Dexia Banque International a Luxembourg",
    // "Diners Club",
    // "DNB Bank ASA",
    // "Dresdner Bank AG",
    // "Far Eastern Bank Ltd",
    // "First Commercial Bank, Ltd",
    // "Fleet National Bank - Head Office",
    // "Habib Bank Ltd",
    // "HL Bank",
    // "Hong Leong Finance Ltd",
    // "Hua Nan Commercial Bank, Ltd",
    // "ICB",
    // "ICICI Bank Limited",
    // "Indian Bank",
    // "INDIAN OVERSEAS BANK",
    // "Industrial & Commercial Bank of China",
    // "ING BANK NV",
    // "Intesa Sanpaolo S.p.A.",
    // "JPMorgan Chase Bank N.A.",
    // "KBC Bank N.V.",
    // "KEB HANA BANK",
    // "Krung Thai Bank PCL",
    // "LANDESBANK BADEN-WURTTEMBERG",
    // "MACQUARIE BANK LIMITED",
    // "Mega Intl Commercial Bank Co., Ltd",
    // "Mizuho Bank, Ltd",
    // "MUFG BANK LTD, SINGAPORE BRANCH",
    // "Natexis Banques Popularies",
    // "National Australia Bank Limited",
    // "NATWEST MARKETS PLC",
    // "Nordea Bank Finland Plc",
    // "OUB",
    // "P.T. Bank Mandiri (Persero)",
    // "Philippine National Bank - Cecil Street",
    // "PT BANK NEGARA INDONESIA (PERSERO)",
    // "Rabobank",
    // "Raiffeisen Zentralbank Osterreich AG",
    // "RHB Bank Berhad",
    // "ROYAL BANK OF CANADA",
    // "SHINHAN BANK",
    // "Singapore Island Bank Ltd",
    // "Skandinaviska Enskilda Banken AB",
    // "Societe Generale - Singapore Branch",
    // "Southern Bank Berhad",
    // "State Bank of India",
    // "Sumitomo Mitsui Banking Corporation",
    // "Svenska Handelsbanken AB (publ)",
    // "The Agricultural Bank of China",
    // "The Bank of Taiwan",
    // "The Korea Development Bank",
    // "The National Bank of Kuwait SAK",
    // "The Norinchukin Bank",
    // "The Siam Commercial Bank PCL",
    // "TORONTO-DOMINION BANK",
    // "TRUST BANK SINGAPORE LIMITED",
    // "UBS AG",
    // "UCO Bank",
    // "UFJ Bank Ltd - Singapore Branch",
    // "Union de Banques Arabes et Francaises",
    // "VTB Capital Plc",
    // "Westpac Banking Corporation",
    // "Woori Bank",

    // "ABSA Bank Ltd",
    // "AMEX",
    // "ANZ Banking Group",
    // "Arab Bank PLC",
    // "Arab Banking Corporation BSC",
    // "Banca Monte dei Paschi di Siena S.p.A.",
    // "Bangkok Bank Public Company Ltd",
    // "Bank of China Limited",
    // "Bank of Communications",
    // "Bank of East Asia Ltd",
    // "Bank of India",
    // "Bank of New Zealand",
    // "Bank of Nova Scotia",
    // "Bank of Tokyo - Mitsubishi Ltd",
    // "Bayerische Hypo-Und Vereinsbank",
    // "BNP Paribas",
    // "BOA",
    // "Chang Hwa Commercial Bank Ltd",
    // "China CITIC Bank International Ltd",
    // "China Construction Bank",
    // "Cho Hung Bank",
    // "CIMB Bank Berhad",
    // "Citibank",
    // "Citibank Singapore Limited",
    // "Commerzbank Aktiengesellschaft",
    // "Compagnie Financiere de CIC et de",
    // "Credit Agricole Corporate & Investment Bank-SG BR",
    // "CTBC Bank Co., Ltd",
    // "DBS",
    // "Deutsche Bank AG",
    // "Dexia Banque International a Luxembourg",
    // "Diners Club",
    // "DNB Bank ASA",
    // "Dresdner Bank AG",
    // "Far Eastern Bank Ltd",
    // "First Commercial Bank, Ltd",
    // "Fleet National Bank - Head Office",
    // "Habib Bank Ltd",
    // "HL Bank",
    // "Hong Leong Finance Ltd",
    // "HSBC",
    // "HSBC Bank (Singapore) Limited",
    // "Hua Nan Commercial Bank, Ltd",
    // "ICB",
    // "ICICI Bank Limited",
    // "Indian Bank",
    // "Industrial & Commercial Bank of China",
    // "ING Bank N.V.",
    // "Intesa Sanpaolo S.p.A.",
    // "JPMorgan Chase Bank N.A.",
    // "KBC Bank N.V.",
    // "Korea Exchange Bank",
    // "Krung Thai Bank PCL",
    // "LANDESBANK BADEN-WURTTEMBERG",
    // "Maybank",
    // "Mega Intl Commercial Bank Co., Ltd",
    // "Mizuho Bank, Ltd",
    // "Monetary Authority of Singapore",
    // "Natexis Banques Popularies",
    // "National Australia Bank Limited",
    // "Nordea Bank Finland Plc",
    // "OCBC",
    // "Others",
    // "OUB",
    // "P.T. Bank Mandiri (Persero)",
    // "P.T.Bank Negara Indonesia(Persero)Tbk",
    // "Philippine National Bank - Cecil Street",
    // "Rabobank",
    // "Raiffeisen Zentralbank Osterreich AG",
    // "RHB Bank Berhad",
    // "Singapore Island Bank Ltd",
    // "Skandinaviska Enskilda Banken AB",
    // "Societe Generale - Singapore Branch",
    // "Southern Bank Berhad",
    // "Standard Chartered Bank",
    // "Standard Chartered Bank Singapore Limited",
    // "State Bank of India",
    // "Sumitomo Mitsui Banking Corporation",
    // "Svenska Handelsbanken AB (publ)",
    // "The Agricultural Bank of China",
    // "The Bank of Taiwan",
    // "The Korea Development Bank",
    // "The National Bank of Kuwait SAK",
    // "The Norinchukin Bank",
    // "The Royal Bank of Scotland plc",
    // "The Siam Commercial Bank PCL",
    // "UBS AG",
    // "UCO Bank",
    // "UFJ Bank Ltd - Singapore Branch",
    // "Union de Banques Arabes et Francaises",
    // "UOB",
    // "VTB Capital Plc",
    // "Westpac Banking Corporation",
    // "Woori Bank",

    // "BNP Paribas",
    // "Bangkok Bank Public Company Ltd",
    // "Bank of America NA",
    // "Bank of China Limited",
    // "Bank of East Asia Ltd",
    // "Bank of India",
    // "CIMB Bank Berhad",
    // "CTBC Bank Co., Ltd",
    // "Citibank NA",
    // "Citibank Singapore Limited",
    // "Commerzbank AG",
    // "Credit Agricole Corporate and Investment Bank",
    // "DBS Bank Ltd / POSB",
    // "Deutsche Bank AG",
    // "First Commercial Bank,Ltd",
    // "GPay Network (S) Pte Ltd",
    // "HL Bank",
    // "HSBC Bank (Singapore) Limited",
    // "HongKong & Shanghai Banking Corporation Ltd",
    // "ICICI Bank Limited",
    // "Indian Bank",
    // "Indian Overseas Bank",
    // "Industrial and Commercial Bank of China Limited",
    // "Intesa Sanpaolo S.p.A",
    // "JPMorgan Chase Bank, N.A.",
    // "Korea Exchange Bank",
    // "Liquid Group Pte Ltd",
    // "MUFG Bank, Ltd",
    // "MatchMove Pay Pte Ltd",
    // "Mizuho Bank, Ltd",
    // "National Australia Bank Ltd",
    // "Overseas-Chinese Banking Corporation Ltd",
    // "P.T.Bank Negara Indonesia(Persero)Tbk",
    // "Qatar National Bank SAQ",
    // "RHB Bank Berhad",
    // "Sing Investments & Finance Limited",
    // "SingCash Pte Ltd",
    // "Singapura Finance Ltd",
    // "Skandinaviska Enskilda Banken AB (publ)",
    // "Societe Generale",
    // "Standard Chartered Bank (Singapore) Limited",
    // "State Bank of India",
    // "Sumitomo Mitsui Bank Ltd",
    // "Transferwise Singapore Pte Ltd",
    // "UCO Bank",
    // "UniCredit Bank AG",
    // "Union Bank of Switzerland AG",
    // "United Overseas Bank Ltd"

];
export default banklist